import React from 'react';
import classnames from 'classnames';
import { Bubble } from 'tea-component';
import type { IBaseProps, IShortcut } from '@intelligence/components/GenreSelect/types';

import '@intelligence/components/GenreSelect/components/TagRadius/index.scss';

interface ITagRadiusProps extends IBaseProps {
  disabled?: boolean;
  data: IShortcut;
  label?: string;
  onClick?: (payload: IShortcut) => void;
}

const TagRadius: React.FC<ITagRadiusProps> = (props) => {
  const { style, className, disabled = false, data, label, onClick, bubbleLabel } = props;

  return (
    <Bubble dark content={bubbleLabel}>
      <div
        style={style}
        className={classnames('dbi-tag-radius', className, { disabled })}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(data);
        }}
      >
        {label}
      </div>
    </Bubble>
  );
};

export default TagRadius;
